// extracted by mini-css-extract-plugin
export default {"layout-global":"style_layout-global__lWVNl__Is6nu","layout-navigation-wrap":"style_layout-navigation-wrap__rKD-W__Is6nu","back-to-detail":"style_back-to-detail__YAaDU__Is6nu"};